<div style="display: flex;justify-content: center;align-items: center;" *ngIf="this.showLoader">
  <img src="../../../../../assets/images/buffering.gif" width="50" height="50"/>
</div>
<div *ngIf="!this.showLoader">
    <div> 
      <div class="row multi-steps-wrap">
        <ul class="list-unstyled multi-steps" *ngIf="this.viewData.registrationType != this.nonreturnable" style="margin: auto;">
          <li class="job-status job-created" [ngClass]="{'job-inprogress is-active negative': statusId == this.created}" >Created</li>
          <li class="job-status job-packed" [ngClass]="{'job-inprogress is-active negative': statusId == this.checked}" >Materials Checked</li>
          <li class="job-status job-packed" *ngIf="this.viewData.statusId==this.declined" [ngClass]="{'job-inprogress is-active declined': statusId == this.declined}" >Declined</li>
          <li class="job-status job-packed" [ngClass]="{'job-inprogress is-active negative': statusId == this.collected}" >Materials collected by recipient</li>
          <li class="job-status job-completed" [ngClass]="{'job-inprogress is-active negative': statusId == this.challan}" >Challan Uploaded</li>
          <li class="job-status job-closed" *ngIf="showTrOpen()">
            Transaction Open
          </li>
          <li class="job-status job-closed" *ngIf="this.viewData.statusId==this.received" [ngClass]="{'job-inprogress is-active negative': statusId == this.received}">
            Transaction Complete
          </li>
        </ul>

        <ul class="list-unstyled multi-steps" *ngIf="this.viewData.registrationType == this.nonreturnable" style="margin: auto;">
          <li class="job-status job-created" [ngClass]="{'job-inprogress is-active negative': statusId == this.created}" >Created</li>
          <li class="job-status job-packed" [ngClass]="{'job-inprogress is-active negative': statusId == this.checked}" >Materials Checked</li>
          <li class="job-status job-packed" *ngIf="this.viewData.statusId==this.declined" [ngClass]="{'job-inprogress is-active declined': statusId == this.declined}" >Declined</li>
          <li class="job-status job-packed" [ngClass]="{'job-inprogress is-active negative': statusId == this.collected}" >Materials collected by recipient</li>
          <li class="job-status job-completed" [ngClass]="{'job-inprogress is-active negative': statusId == this.challan}" >Challan Uploaded</li>
        </ul>
      </div>
</div>

